/**
 * Returns the full public URL for a persona slug.
 * Reads VITE_APP_URL at build time; falls back to the current origin at runtime
 * so dev and staging automatically use the right domain.
 *
 * Production:  VITE_APP_URL=https://questionme.io
 * Staging:     VITE_APP_URL=https://questionme-staging.vercel.app
 * Dev:         unset → window.location.origin (e.g. http://localhost:4200)
 */
export function appUrl(slug) {
  const base = (import.meta.env.VITE_APP_URL ?? "").replace(/\/$/, "")
    || (typeof window !== "undefined" ? window.location.origin : "");
  return slug ? `${base}/${slug}` : base;
}
